
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/withdrawal-form",
      function () {
        return require("private-next-pages/withdrawal-form.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/withdrawal-form"])
      });
    }
  